var SENTRY_RELEASE;SENTRY_RELEASE={name: "Recital Master", version: "1.0.0"};